import SitecoreTextModel from '@models/SitecoreTextModel';
import { deepCopy } from '@utils/utility';

import SubAccordionModel from './SubAccordionModel';

export default class FieldsModel {
  constructor() {
    this['Description'] = new SitecoreTextModel();

    this['Title'] = new SitecoreTextModel();

    this['items'] = [];
  }

  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Description')) {
      this['Description'].getData(dataSource['Description']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Title')) {
      this['Title'].getData(dataSource['Title']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'items')) {
      let tempArr = [];

      dataSource['items'].map((item) => {
        tempArr.push(new SubAccordionModel().getData(deepCopy(item) || {}));
      });

      this['items'] = tempArr;
    }

    return this;
  }
}
